<template>
  <div id="app">
    <login-lessee-dialog />
    <my-message-send v-if="message.show" />
    <ws-customer-service v-if="$store.state.isLogin && $store.state.aiChatEnabled === '1'" />
    <router-view></router-view>
  </div>
</template>

<script>
import LoginLesseeDialog from "@/components/login-lessee-dialog.vue";

export default {
  name: "app",
  components: {LoginLesseeDialog},
  data() {
    return {
      message: this.MessageSend.message,
    };
  },
  metaInfo() {
    const title =
      this.$store.state.tenantConfig.name ||
      window.sessionStorage.getItem('pageShTitle') ||
      'Trade with Trust, Forever.';

    return {
      title
    };
  },
  beforeMount() {
    if(!window.sessionStorage.getItem('tenant-id')){
      window.sessionStorage.setItem('tenant-id', '1')
    }
  }
};
</script>

<style>
.flex-row {
  display: flex;
  flex-direction: row;
}

.flex-column {
  display: flex;
  flex-direction: column;
}

.flex-col {
  display: flex;
  flex-direction: column;
}

.flex-between {
  display: flex;
  justify-content: space-between;
}

.flex-1 {
  flex: 1;
}

.flex-2 {
  flex: 2;
}

.flex-grow {
  flex-grow: 1;
}

.justify-center {
  display: flex;
  justify-content: center;
}

.align-center {
  display: flex;
  align-items: center;
}

.flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.flex-wrap {
  display: flex;
  flex: wrap;
  display: -webkit-flex;
  /* Safari */
  -webkit-flex-wrap: wrap;
  /* Safari 6.1+ */
}

.text-nowrap {
  white-space: nowrap;
}
.text-wrap {
  word-break: break-all;
}
.text-overflow {
  text-overflow: ellipsis;
  overflow: hidden;
}

.text-row-1 {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  text-overflow: ellipsis;
  overflow: hidden;
}

.text-row-2 {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  overflow: hidden;
  word-wrap: break-word;
}

.text-row-3 {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  text-overflow: ellipsis;
  overflow: hidden;
  word-wrap: break-word;
}

.text-align {
  text-align-last: justify;
  text-align: justify;
}
</style>
